import AuctionLotsListing from './auction-lots-listing';
export default AuctionLotsListing;